<template>
  <Admin>
    <v-main>
      <v-container fluid>
        <v-row justify="center">
          <v-col>
            <document-table></document-table>
          </v-col>
        </v-row>
        <v-row justify="start">
          <v-col>
            <Pagination v-if="!keyword" collection-name="docs"></Pagination>
            <PaginationWithKeyword
              v-if="keyword"
              collection-name="docs"
            ></PaginationWithKeyword>
          </v-col>
        </v-row>
        <v-row> </v-row>
      </v-container>
    </v-main>
  </Admin>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Admin from "../../components/admin/admin-main-template";
import DocumentTable from "../../components/admin/documents/table";
import Pagination from "../../components/admin/pagination";
import PaginationWithKeyword from "../../components/admin/pagination-with-keyword";
import logActivity from "@/libs/activityLogger";

export default {
  name: "Document",
  components: {
    Admin,
    DocumentTable,
    Pagination,
    PaginationWithKeyword,
  },
  computed: mapState({
    docs: (state) => state.docs.list,
    keyword: (state) => state.docs.keyword,
    summaryAll: (state) => state.docs.summaryAll,
  }),
  methods: {
    ...mapActions({
      resetKeyword: "docs/resetKeyword",
      setSelectedList: "docs/setSelectedList",
    }),
  },
  beforeRouteLeave(to, from, next) {
    // console.log("current", from.path, '->', to.path);
    this.resetKeyword();
    this.setSelectedList({ selectedList: [] })
    next();
  },
  beforeRouteEnter(to, from, next) {
    const paths = to.path.split("/").slice(1);
    logActivity('page_view', { page_title: `${paths?.[1]}` });
    next();
  },
};
</script>
